import { adminInstance } from "@/api/instance";

export default async function (lectureId) {
  return adminInstance.get(`/lecture/${lectureId}`);
}
